<div class="content-footer">
  <div class="footer-img">
    <span>Powered by</span>
    <img src="assets/images/bizdata-header-logo.png">
  </div>
  <div class="footer-text">&copy; {{currentYear}} Bizdata Inc. All rights reserved | <a href="https://www.bizdata360.com/legal-terms/" target="_blank">Terms of use</a> | <a
      href="https://www.bizdata360.com/privacy-policy/" target="_blank">Privacy policy</a></div>
</div>